import React, { useEffect, useRef } from "react";
import { useStore } from "./store";
import { observer } from 'mobx-react';

const TestPage: React.FC = () => {

    const { testStore } = useStore();
    const isCancelled = useRef(false);

    useEffect(
        () => {

            const fetchData = async () => {
                const data = await fetch('/api/dictionaries/sources?subject=MATH');
                const json = await data.json();

                if (!isCancelled.current) {
                    testStore.setList(json);
                }
            }

            fetchData().catch(console.error);
            return () => {
                isCancelled.current = true;
            };

        }
        , [testStore]
    );

    return (
        <div>
            <h1>This is test list</h1>
            {testStore.list.map((i) => <div key={i.id}>{i.id}: {i.name}</div>)}
        </div>
    );
}

export default observer(TestPage);